import {Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-opening',
  templateUrl: './opening.component.html',
  standalone: true,
  styleUrls: ['./opening.component.less']
})
export class OpeningComponent {
  @ViewChild('opening') opening!: ElementRef;
  show: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId) || !this.opening?.nativeElement) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.opening.nativeElement.getBoundingClientRect();

    if (boundingRectFive.bottom <= windowHeight) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
